import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ResponsiveService } from '../../services/reponsive.service';
import { LucideAngularModule } from 'lucide-angular';
import { AsyncPipe, DatePipe, NgClass, TitleCasePipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from "../../components/boutons/button/button.component";
import { LoginService } from '../../services/login.service';
import { Plan } from '../../class/plan.class';
import { selectClient, selectClientPlan, selectClientTokensPerMonth } from '../../store/client/client.selects';
import { LanguagesSwitcherComponent } from '../../components/languages-switcher/languages-switcher.component';
import { StripeService } from '../../stripe.service';
import { ClientModel } from '../../models/client.model';
import { Dialog, DialogRef } from '@angular/cdk/dialog'
import { ConfirmModalComponent } from '../../components/modals/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-profile',
  imports: [
    LucideAngularModule,
    DatePipe,
    RouterLink,
    NgClass,
    AsyncPipe,
    TitleCasePipe,
    TranslateModule,
    ButtonComponent,
    AsyncPipe,
    LanguagesSwitcherComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  clientPlan$: Observable<Plan | null> = this.store.select(selectClientPlan);
  clientTokenPerMonth$: Observable<number> = this.store.select(selectClientTokensPerMonth)

  subscriptions: Subscription[] = [];

  client$: Observable<ClientModel | null> = this.store.select(selectClient)

  constructor(
    private responsiveService: ResponsiveService,
    public loginService: LoginService,
    private store: Store,
    private stripeService: StripeService,
    private dialog: Dialog,
    private translateService: TranslateService,
  ) { }

  cancelPlan() {
    this.stripeService.cancelPlan().subscribe({
      next: (value) => {
        console.log('Cancel plan', value)
      },
      error: (err: Error) => {
        console.error(err)
      },
    })
  }

  deleteAccount(): void {
    this.loginService.deleteAccount().subscribe({
      next: (value: any) => {
        this.loginService.logout();
      }
    });
  };

  openCancelPlanModal(endDate: string | null, tokensLeft: number | null): void {
    const dialogRef: DialogRef<unknown, ConfirmModalComponent> = this.dialog.open(ConfirmModalComponent, {
      width: '500px'
    });
    const confirmModalComponent = dialogRef.componentInstance as ConfirmModalComponent;
    confirmModalComponent.content = `Êtes-vous sûr de vouloir supprimer votre compte ? Si vous supprimez votre vous disposerai de vos ${tokensLeft} tokens restant jusqu'au ${endDate}. Passez cette date vous disposerez d'un plan Starter.`;
    confirmModalComponent.confirm = this.translateService.instant('modal.cancel_plan.confirm');
    confirmModalComponent.onConfirm.subscribe(() => {
      this.cancelPlan();
      dialogRef.close();
    });
  }

  openDeleteAccountModal(): void {
    const dialogRef: DialogRef<unknown, ConfirmModalComponent> = this.dialog.open(ConfirmModalComponent, {
      width: '500px'
    });
    const confirmModalComponent = dialogRef.componentInstance as ConfirmModalComponent;
    confirmModalComponent.content = this.translateService.instant('modal.delete_account.content');
    confirmModalComponent.confirm = this.translateService.instant('modal.delete_account.confirm');
    confirmModalComponent.onConfirm.subscribe(() => {
      this.deleteAccount();
      dialogRef.close();
    });
  }

  openLogoutModal(): void {
    const dialogRef: DialogRef<unknown, ConfirmModalComponent> = this.dialog.open(ConfirmModalComponent, {
      width: '500px'
    });
    const confirmModalComponent = dialogRef.componentInstance as ConfirmModalComponent;
    confirmModalComponent.content = 'Êtes-vous sûr de vouloir vous déconnecter ?';
    confirmModalComponent.onConfirm.subscribe(() => {
      this.loginService.logout();
      dialogRef.close();
    });
  }

}
